export default __webpack_public_path__ + "recenter-1200-6db9ee107bb98f0a1ffa971250aa62e9.webp";